import React, { useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import config from "../../config/config";
import { isEmpty } from "../../Actions/common";
import { addCmsAxios, editCmsAxios } from "../../Actions/axios";
import {toast} from 'react-toastify'

const AnnouncementAdd = () => {
  const [data, setData] = useState({});
  const [content, setContent] = useState("");
  const navigate = useNavigate();

  const Addcms = async () => {
    let sendData = {
      ...data,
      content,
    };
    let resp = await addCmsAxios(sendData);
    console.log("🚀 ~ editCms ~ resp:", resp);
    if(resp?.status){
        toast.success(resp?.message);
        navigate('/announcementlist')
    }else{
        toast.error(resp?.message)
    }
  };

  return (
    <div className="cmsedit">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>
      <h1 className="pagehead">{data?.slug?.toUpperCase()}</h1>
      <div className="cardbox">
        <Form>
          <Row>
            <Col xs={12} sm={12} md={8} lg={9} xl={7} xxl={7} className="mb-4">
              <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Control
                  value={data?.title}
                  onChange={(e) =>
                    setData({ ...data, ["title"]: e.target.value })
                  }
                  type="text"
                />
              </Form.Group>
            </Col>

            <Col xs={12} lg={10} xl={7} xxl={7}>
              <Form.Group className="mb-4">
                <Form.Label>Content</Form.Label>
                
                  <SunEditor
                      defaultValue={content ?? '<p>Hello</p>'}
                    onChange={(e) => setContent(e)}
                    height={300}
                  />
                
              </Form.Group>
            </Col>

            <Col xs={12} sm={6} className="mb-4">
              <Form.Group>
                <Form.Label>Image</Form.Label>

                <div className="uploadimgbox">
                  <img
                    src={
                      data?.file
                        ? URL.createObjectURL(data?.file)
                        : `${config.Back_URL}cms/${data?.images}`
                    }
                    alt="user"
                    className="img-fluid"
                  />
                  <Form.Control
                    type="file"
                    onChange={(e) =>
                      setData({ ...data, file: e.target?.files[0] })
                    }
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <button
          type="button"
          onClick={() => Addcms()}
          className="btn sitebtn py-2 px-3 mt-4"
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AnnouncementAdd;
